import '.d{display:flex;}.ssr-plugin'
import '.aq{gap:2rem;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import '.z{align-items:center;}.ssr-plugin'
import { styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { FaqItem } from './FaqItem'

export type FaqSectionItem = {
  question: string
  answer: string
}

export type FaqSectionProps = {
  items: ReadonlyArray<FaqSectionItem>
  isMobile: boolean
  title: string
  subtitle?: string
}

const FaqSection = ({
  items,
  isMobile,
  title,
  subtitle,
}: FaqSectionProps) => {
  return (
    <div className="d aq"
      style={{
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'stretch' : 'center',}}
    >
      <div className="d e g z"
        style={{
          width: isMobile ? '100%' : '45%',}}
      >
        <Title.H2 style={{ marginBottom: 0 }}>{title}</Title.H2>
        {subtitle && <Text.Medium>{subtitle}</Text.Medium>}
      </div>
      <div
        style={{
          width: isMobile ? '100%' : '55%',
        }}
      >
        {items.map((item) => (
          <FaqItem
            key={item.question}
            question={item.question}
            answer={item.answer}
          />
        ))}
      </div>
    </div>
  )
}

export default FaqSection
